<template>
  <mv-page>
    <mv-default-row>
      <v-layout row wrap>
          <v-flex xs12>
            <v-card flat>
              <v-card-text>
                <h2 v-if="confirmed">{{confirmed}}</h2>
              </v-card-text>
            </v-card>
          </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>

<script>
export default {
  data: () => ({
    confirmkey: null,
    confirmed: null
  }),
  methods: {
    async reject () {
      if (!this.connected) return null
      if (!this.confirmkey) return null
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'emailboxes-create-reject',
          pl: {
            secret: this.confirmkey
          }
        })
        this.$store.dispatch('snack', meta.msg)
        this.confirmed = meta.msg
      } catch (err) {
        this.$store.dispatch('snack', err)
        this.confirmed = err.toString()
      }
    }
  },
  computed: {
    connected () {
      return this.$store.state.connected
    }
  },
  watch: {
    async connected (val) {
      if (val) await this.reject()
    }
  },
  async mounted () {
    this.confirmkey = this.$route.query.confirmkey
    if (this.connected) await this.reject()
  }
}
</script>

<style lang="css">
</style>
